import React from 'react'

const HomePageAboutUs = () => {
  return (
    <article className="pt4-00 container container80 "
    >
        <header className="tc container w-100 w-60-m pv2-00"
        >
            <h2 className="f3-00"
            >
                About Us
            </h2>
            <p className="tc f1-50 f2-50-s">
                A global leader in <br/> next-generation <br/> digital services and consulting
            </p>
        </header>
        <main id=""
            className="white-90"
        >
            <div 
                className="grid gtc12 mb4-00 justify-center items-center w-100"
            >
                <div className="gc5s4 gr1s1">
                    <figure className="flex flex-column pa0-00 ma2-00 items-center justify-center">
                    
                        <figcaption className=" 
                            white-90 tc"
                        >
                            <h2 className="f2-00 f4-00-m">
                                0 %
                            </h2>
                            <h3 className="fw6 tc f0-75">
                                Service Offerings 
                            </h3>
                        </figcaption>
                        
                    </figure>
                </div>
                <div className="gc9s4 gr1s1">
                    <figure className="flex flex-column pa0-00 ma2-00 items-center justify-center">
                    
                        <figcaption className=" 
                            white-90 tc"
                        >
                            <h2 className="f2-00 f4-00-m">
                                0%
                            </h2>
                            <h3 className="fw6 tc f0-75">
                                Service Offerings 
                            </h3>
                        </figcaption>
                        
                    </figure>
                </div>
                <div className="gc1s4 gr1s1">
                    <figure className="flex flex-column pa0-00 items-center justify-center">
                    
                        <figcaption className=" 
                            white-90 tc"
                        >
                            <h2 className="f2-00 f4-00-m">
                                1M +
                            </h2>
                            <h3 className="fw6 tc f0-75">
                                training (hours) conducted for employees.
                            </h3>
                        </figcaption>
                        
                    </figure>
                </div>
            </div>    

            <div className="grid gtc12 ggap0-50 mb4-00 container">
                <div className="gc1s12 gr1s1 gc1s6-m gr1s2-m">
                    <figure className="grid h-100 w-100 h0-00-s pb-100-s ba">
                        <img src="" 
                            alt=""
                            className="gc1s1 gr1s1"
                        />
                        <figcaption className="pa1-00 gc1s1 gr1s1 h-100">
                            <h3 className="fw6">
                                1
                            </h3>
                            <h3 className="fw4 f1-50 ">
                                Company Story
                            </h3>
                            <p className="fw2">
                                
                            </p>
                        </figcaption>
                    </figure>
                </div>
                <div className="gc1s12 gr2s1 gc1s6-s gr2s1-s  gc7s3-m gr1s1-m">
                    <figure className="grid h-100 h0-00-s pb-100-s w-100 pa0-00 ba">
                        <img src="" 
                            alt=""
                            className="gc1s1 gr1s1"
                        />
                        <figcaption className="pa1-00 gc1s1 gr1s1">
                            <h3 className="fw6">
                                2
                            </h3>
                            <h3 className="fw4 f1-50 ">
                                Mission, Vision, and Values
                            </h3>
                            <p className="fw2">
                                
                            </p>
                        </figcaption>
                    </figure>
                </div>
                <div className="gc1s12 gr3s1 gc7s6-s gr2s1-s gc7s3-m gr2s1-m">
                        <figure className="grid h-100 h0-00-s pb-100-s w-100 pa0-00 ba">
                        <img src="" 
                            alt=""
                            className="gc1s1 gr1s1"
                        />
                        <figcaption className="pa1-00 gc1s1 gr1s1">
                            <h3 className="fw6">
                                3
                            </h3>
                            <h3 className="fw4 f1-50 ">
                                Founder Profile
                            </h3>
                            <p className="fw2">
                                
                            </p>
                        </figcaption>
                    </figure>
                </div>
                <div className="gc1s12 gr4s1 gc1s6-s gr3s1-s gc10s3-m gr1s1-m">
                    <figure className="grid h-100 h0-00-s pb-100-s w-100 pa0-00 ba">
                        <img src="" 
                            alt=""
                            className="gc1s1 gr1s1"
                        />
                        <figcaption className="pa1-00 gc1s1 gr1s1">
                            <h3 className="fw6">
                                4 
                            </h3>
                            <h3 className="fw4 f1-50 ">
                                Partnerships and Alliances
                            </h3>
                            <p className="fw2">
                                
                            </p>
                        </figcaption>
                    </figure>
                </div>
                <div className="gc1s12 gr5s1 gc7s6-s gr3s1-s gc10s3-m gr2s1-m"
                >
                        <figure className="grid h-100 w-100  h0-00-s pb-100-s pa0-00 ba"
                        >
                        <img src="" 
                            alt=""
                            className="gc1s1 gr1s1"
                        />
                        <figcaption className="pa1-00 gc1s1 gr1s1"
                        >
                            <h3 className="fw6">
                                5 
                            </h3>
                            <h3 className="fw4 f1-50 ">
                                Why KDA Design Technologies?
                            </h3>
                            <p className="fw2">
                                
                            </p>
                        </figcaption>
                    </figure>
                </div>
            </div>
        </main>
        <footer className="mb4-00">

        </footer>
    </article>
  )
}

export default HomePageAboutUs